import React from 'react';
import Box from '@material-ui/core/Box';
import FPAvatar from 'UI/components/atoms/FPAvatar';
import Text from 'UI/components/atoms/Text';
import { colors } from 'UI/res';

import { styles } from './style';

/**
 * @typedef {Object} UserCommentsProps
 * @property {string} avatarInitials
 * @property {string} date
 * @property {string} author
 * @property {string} note
 */

/**
 * @param {UserCommentsProps} props
 */
const UserComments = props => {
  const { avatarInitials, date, author, note } = props;
  return (
    <div style={styles.reasonsContainer}>
      <Box pr={2}>
        <FPAvatar backgroundColor={colors.success}>{avatarInitials}</FPAvatar>
      </Box>
      <div>
        <Box display="flex">
          <Text variant="subtitle1" text={author} fontSize={16} />
          <span style={styles.date}>{date}</span>
        </Box>
        <div style={styles.reasonsText}>{note}</div>
      </div>
    </div>
  );
};

export default UserComments;
